import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import Loader from '../../../../components/Feedback/Loader';
import DiagnosisEditForm from './DiagnosisEditForm';
import baseService from '../../../../services/base';

async function fetchArrayData(url) {
 const response = await baseService.get(url);
 const objectResponse = response?.data?.[0];
 return objectResponse;
}

export default function DiagnosisEdit() {
 const { id: surveyId } = useParams();

 const [isFormUpdated, setIsFormUpdated] = useState(false);
 const [defaultValues, setDefaultValues] = useState();

 const { data, isLoading, mutate } = useSWR(
  surveyId ? `survey/diagnostic/${surveyId}/survey` : null,
  fetchArrayData
 );

 const fetchPillarData = async (surveyId, themeRef, pillarId) => {
  const response = await baseService.get(
   `/survey/diagnostic/${surveyId}/pillar?id_theme=${themeRef}&id_pillar=${pillarId}`
  );
  return response?.data;
 };

 useEffect(() => {
  const fetchData = async () => {
   if (data && data?.pillars?.length && !isFormUpdated) {
    const sortedPillars = data?.pillars?.sort((a, b) => a.id_pillar - b.id_pillar);

    const { description } = data;

    const form = await Promise.all(
     sortedPillars.map(async (pillar) => {
      const uniqueLevels = [...new Set(pillar?.themes?.[0]?.niveis)];
      const id_theme = pillar?.themes?.[0]?.id_theme;

      const pillarData = await fetchPillarData(surveyId, id_theme, pillar?.id_pillar);

      const levels = pillarData?.questions_theme?.map(({ nivel, questions }) => ({
       nivel,
       questions: questions.map((question) => question?.id_question_template),
      }));

      return {
       pillarId: pillar.id_pillar,
       pillarName: pillar.name_pillar,
       numberOfThemes: pillar.themes.length.toString(),
       numberOfLevels: uniqueLevels.length.toString(),
       pillarText: pillar.text_pillar,
       pillarImage: pillar.img_pillar,
       helpTitle: pillar.helper_title,
       helpText: pillar.helper_text,
       themes: pillar?.themes?.map((theme) => {
        return { title: theme?.title, id_theme: theme?.id_theme };
       }),
       levels,
      };
     })
    );

    setDefaultValues({
     name: description,
     form,
    });

    setIsFormUpdated(true);
   }
  };

  fetchData();
 }, [data, surveyId, isFormUpdated]);

 if ((isLoading || !isFormUpdated) && !defaultValues) {
  return <Loader />;
 }

 return <DiagnosisEditForm defaultValues={defaultValues} data={data} mutate={mutate} />;
}
